import React, { useState, useEffect, useContext } from "react";
// import profile from "../../assets/images/profilepic.jpeg";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { UserContext } from "../../context/UserContext";
import StarBorder from "@mui/icons-material/StarBorder";
import { Button } from "@material-ui/core";
import Avatar from "@mui/material/Avatar";
import { data } from "../../data/data";
import axios from "axios";

import {
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddIcon from "@mui/icons-material/Add";

function LeftHome({ closeForm, setCloseForm }) {
  const [open, setOpen] = React.useState(true);
  const [userDetails, setUserDetails] = useState({});

  const { user } = useContext(UserContext);

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    axios
      .get("api/user/", {
        headers: {
          "x-auth-token": localStorage.getItem("user"),
        },
      })
      .then((res) => {
        setUserDetails(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="leftHome">
      {/* <div className="leftProfile"> */}
      <div className="profilePic">
        {/* <img className='pic' src={profile} /> */}
        {user && (
          <Avatar alt="Profile Pic" className="avatar" src={userDetails.pic} />
        )}
      </div>

      <div className="info info_name">
        {user && <h1>{userDetails.fullName}</h1>}
      </div>

      <div className="info info_username">
        {user && <h1>{userDetails.username}</h1>}
      </div>

      <Button
        className="update_btn"
        variant="contained"
        onClick={(e) => {
          e.preventDefault();
          setCloseForm(!closeForm);
        }}
      >
        <AddIcon sx={{ color: "white" }} />
        <span className="edit_txt">ADD POST</span>
      </Button>
      {/* </div> */}

      <FormControl className="filter">
        <FormLabel id="demo-radio-buttons-group-label" className="header">
          Filters
        </FormLabel>

        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="all"
          name="radio-buttons-group"
        >
          <List
            sx={{ width: "100%", bgcolor: "background.paper" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            <ListItemButton sx={{ width: "100%", bgcolor: "background.paper" }}>
              <ListItemIcon>
                <FormControlLabel
                  value="Upvotes"
                  control={<Radio />}
                  label="Upvotes"
                />
              </ListItemIcon>
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <FormControlLabel
                  value="Recents"
                  control={<Radio />}
                  label="Recents"
                />
              </ListItemIcon>
            </ListItemButton>
            <ListItemButton onClick={handleClick}>
              <ListItemText>Skills</ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemIcon>
                    <FormControlLabel
                      value="MERN"
                      control={<Radio />}
                      label="MERN"
                    />
                    <FormControlLabel
                      value="Dev"
                      control={<Radio />}
                      label="Dev"
                    />
                    <FormControlLabel value="C" control={<Radio />} label="C" />
                    <FormControlLabel
                      value="Java"
                      control={<Radio />}
                      label="Java"
                    />
                  </ListItemIcon>
                </ListItemButton>
              </List>
            </Collapse>
          </List>
        </RadioGroup>
      </FormControl>
    </div>
  );
}

export default LeftHome;
